import React, { useEffect, useState } from 'react'
import ReactApexChart from "react-apexcharts";

function Currencypair({data}) {

    const [chartData, setChartData] = useState({
        series: [44, 55, 41, 17, 15,18, 21],
        options: {
            chart: {
                type: "donut",
            },
            labels: ["USDT", "FDUSD", "USDC", "TRY", "BTC","EUR","BRL"],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: "100%",
                        },
                        legend: {
                            position: "bottom",
                        },
                    },
                },
            ],
        },
    });

    useEffect(()=>{
        if(data){
           setChartData({...chartData,["series"] : Object.values(data),["options"] : { ...chartData?.options,["labels"] : Object.keys(data) }})
        }
       },[data])

    return (

        <div>
            <div id="chart">
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </div>

    )
}

export default Currencypair;